<template>
  <section :key="catalogKey" class="catalog">
    <div class="catalog__container container">
      <!-- items -->
      <div ref="slider" class="catalog-slider">
        <ul class="catalog-viewport">
          <catalog-item
            v-for="(item, index) in items"
            :key="index"
            v-bind="item"
            @select="() => handleSelect(item)"
          />
        </ul>
      </div>

      <!-- arrows -->
      <button
        class="catalog__arrow catalog__arrow_prev"
        @click="onPrev"
      ></button>
      <button
        class="catalog__arrow catalog__arrow_next"
        @click="onNext"
      ></button>
    </div>
  </section>
</template>

<script>
import EmblaCarousel from "embla-carousel";
import CatalogItem from "./item";

export default {
  name: "Slider",

  components: {
    CatalogItem
  },

  props: {
    items: Array
  },

  data() {
    return {
      catalogKey: 0
    };
  },

  watch: {
    items: {
      immediate: true,
      handler() {
        this.initSlider();
      }
    }
  },

  methods: {
    initSlider() {
      this.embla = null;

      this.$nextTick(() => {
        this.embla = EmblaCarousel(this.$refs.slider, {
          slidesToScroll: 7
        });

        this.autoSelect();
      });
    },
    autoSelect() {
      const activeItem = this.items.find(({ active }) => active);
      if (!activeItem) return;

      this.handleSelect(activeItem);
    },

    handleSelect(item) {
      this.$emit("select", JSON.parse(JSON.stringify(item)));
    },

    onPrev() {
      this.embla.scrollPrev();
    },
    onNext() {
      this.embla.scrollNext();
    }
  }
};
</script>

<style>
@import "./index.css";
</style>
